import styled from 'styled-components'
import { ArrowDownIcon, ArrowUpIcon } from '@pancakeswap/uikit'
import { BetPosition } from 'state/types'
import { useTranslation } from '@pancakeswap/localization'

interface PositionLabelProps {
  position: BetPosition
}

const StyledPositionLabel = styled.div<{ bgColor: string }>`
  align-items: center;
  background-color: ${({ theme, bgColor }) => theme.colors[bgColor]};
  border-radius: 8px;
  display: inline-flex;
  justify-content: center;
  width: fit-content;
  height: 36px;
  padding: 8px 12px;
  min-width: 16px;
  padding-left: 8px;
  padding-right: 8px;
  @media screen and (max-width: 700px) {
    width: 40px;
    height: 32px;
  }
`

const Label = styled.div<{ isBull: boolean }>`
  color: ${({ isBull }) => (isBull ? '#000' : '#fff')};
  display: none;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;

  @media screen and (min-width: 768px) {
    display: block;
    margin-left: 4px;
  }
`

const PositionLabel: React.FC<React.PropsWithChildren<PositionLabelProps>> = ({ position }) => {
  const { t } = useTranslation()
  const isBull = position === BetPosition.BULL
  const bgColor = isBull ? 'success' : 'failure'
  const icon = isBull ? <ArrowUpIcon width="16px" color="black" /> : <ArrowDownIcon width="16px" color="white" />

  return (
    <StyledPositionLabel bgColor={bgColor}>
      {icon}
      <Label isBull={isBull}>{isBull ? t('Up') : t('Down')}</Label>
    </StyledPositionLabel>
  )
}

export default PositionLabel
